/*
  pzz-signup.js - shared behaviour for every PZZ newsletter signup form (2026-09-28).
  Markup: snippets/pzz-signup-form.liquid (used by the popup section and the footer block).

  - Submits Shopify's customer form in the background (fetch). Success = Shopify redirects to
    ?customer_posted=true. Anything else (e.g. Shopify's bot check / challenge page) falls back
    to a normal submit so Shopify can handle it; the success state is restored on return.
  - On success: shows the code step, copies on tap, optionally applies the code to the basket
    (/discount/CODE), records the signup in localStorage and fires Umami + a DOM event.

  "Already subscribed" checks (so the popup never nags someone who has joined):
    1. server side, in Liquid: logged-in customers with accepts_marketing are never shown the
       popup, and the footer block shows a "you're subscribed" line instead of the form;
    2. this browser signed up through ANY pzz form (popup, footer): localStorage flag `done`;
    3. the page loaded with ?customer_posted=true, i.e. a Shopify customer form submitted
       normally (Horizon's own signup, the fallback path): sets the same flag.
  Public: window.PZZSignup.isSubscribed(), .state(), .set(obj), .track(name, data)
  Event:  document 'pzz:signup' { detail: { context } }
*/
(function () {
  if (window.PZZSignup) return;
  var KEY = 'pzz-nl-v1';
  var PENDING = KEY + '-pending';

  function state() {
    try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; }
  }
  function set(obj) {
    var s = state();
    for (var k in obj) s[k] = obj[k];
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
    return s;
  }
  function track(name, data) {
    try { if (window.umami) window.umami.track(name, data); } catch (e) {}
  }

  function showStep(root, name) {
    root.querySelectorAll('[data-su-step]').forEach(function (el) { el.hidden = el.getAttribute('data-su-step') !== name; });
  }

  function success(root, silent) {
    set({ done: 1 });
    if (root) {
      showStep(root, 'done');
      var code = root.getAttribute('data-su-code');
      if (root.getAttribute('data-su-apply') === 'true' && code) {
        fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }).catch(function () {});
      }
    }
    var ctx = root ? root.getAttribute('data-su-context') : 'shopify';
    if (!silent) track('newsletter-signup', { form: ctx });
    document.dispatchEvent(new CustomEvent('pzz:signup', { detail: { context: ctx } }));
  }

  function fallbackSubmit(form, root) {
    try { sessionStorage.setItem(PENDING, root.getAttribute('data-su-context') || ''); } catch (e) {}
    form.submit();
  }

  // Capture phase: runs BEFORE Shopify's own spam-protection (hCaptcha) handler, which may
  // cancel our background submit and do a normal page-reloading submit itself. Remember which
  // form was used so the success state can be restored after the reload.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.hasAttribute || !f.hasAttribute('data-su-form')) return;
    var r = f.closest('[data-su]');
    try { sessionStorage.setItem(PENDING, r ? r.getAttribute('data-su-context') || '' : ''); } catch (x) {}
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-su-form')) return;
    var root = form.closest('[data-su]');
    var email = form.querySelector('[name="contact[email]"]');
    var err = root.querySelector('[data-su-error]');
    if (!email.value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
      e.preventDefault();
      if (err) err.hidden = false;
      email.focus();
      return;
    }
    if (err) err.hidden = true;
    if (!window.fetch) return; // very old browser: normal submit
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
      .then(function (r) {
        if (r.url.indexOf('customer_posted=true') !== -1) {
          try { sessionStorage.removeItem(PENDING); } catch (x) {}
          return success(root);
        }
        fallbackSubmit(form, root);
      })
      .catch(function () { fallbackSubmit(form, root); });
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-su-copy]');
    if (!b || !navigator.clipboard) return;
    var root = b.closest('[data-su]');
    navigator.clipboard.writeText(root.getAttribute('data-su-code')).then(function () {
      var h = b.querySelector('[data-su-copy-hint]');
      if (h) h.textContent = 'Copied';
    }).catch(function () {});
  });

  // Check 3 + restore the success state after a normal (page-reloading) submit.
  // With Shopify's spam protection on, newsletter forms reload the page to
  // ?customer_posted=true#<form id>. Find the form that was used (URL hash, else the context
  // remembered at submit), show its code, scroll it into view, and tidy the URL so a later
  // refresh doesn't show it again. The popup reopens itself (see its section script).
  var posted = location.search.indexOf('customer_posted=true') !== -1;
  var pendingCtx = null;
  try { pendingCtx = sessionStorage.getItem(PENDING); sessionStorage.removeItem(PENDING); } catch (e) {}
  if (posted) {
    set({ done: 1 });
    var restore = function () {
      var root = null;
      var hashForm = location.hash ? document.getElementById(location.hash.slice(1)) : null;
      if (hashForm && hashForm.closest) root = hashForm.closest('[data-su]');
      if (!root && pendingCtx) root = document.querySelector('[data-su][data-su-context="' + pendingCtx + '"]');
      if (root) pendingCtx = root.getAttribute('data-su-context');
      success(root, !root);
      if (root && pendingCtx !== 'popup') {
        // after layout settles (fonts/images), bring the code into view
        setTimeout(function () { root.scrollIntoView({ block: 'center', behavior: 'smooth' }); }, 300);
      }
      try {
        var u = new URL(location.href);
        u.searchParams.delete('customer_posted');
        u.hash = '';
        history.replaceState(history.state, '', u.pathname + u.search);
      } catch (e) {}
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore);
    else restore();
  }

  window.PZZSignup = {
    isSubscribed: function () { return !!state().done; },
    state: state,
    set: set,
    track: track,
    pendingContext: pendingCtx,
    posted: posted // page loaded after a successful Shopify signup (URL is tidied afterwards)
  };
})();
